import { usePreviewGlobalUIItemsEffect } from 'components/features/home/Home';
import { WithEmptyString } from 'components/features/home/WithEmptyView';
import { SNSTypes } from 'config/consts';
import { useRouting } from 'hooks/useRouting';
import React, { ComponentProps, useEffect, useState } from 'react';
import { Preview } from './Preview';

const dataURLKey = 'preview-data-url';

const commentKey = 'preview-comment';

const snsKey = 'sns';

const readDataURL = (): string | null => {
  return localStorage.getItem(dataURLKey);
};

const readSNS = (): keyof typeof SNSTypes | null => {
  const value = localStorage.getItem(snsKey);
  return value && Object.keys(SNSTypes).includes(value)
    ? (value as keyof typeof SNSTypes)
    : null;
};

const readComment = (): string | null => {
  return localStorage.getItem(commentKey);
};

const removePreviewLocalStorage = () => {
  [dataURLKey, snsKey, commentKey].forEach(k => localStorage.removeItem(k));
};

export const writePreviewDataURL = (
  dataURL: string,
  comment: string,
  withSNS: keyof typeof SNSTypes
): void => {
  localStorage.setItem(dataURLKey, dataURL);
  localStorage.setItem(snsKey, withSNS);
  localStorage.setItem(commentKey, comment);
};

export const ContinuePreview = () => {
  const [previewData, setPreviewData] = useState<
    | {
        tag: 'Read';
        dataURL: string;
        withSNS: keyof typeof SNSTypes;
        comment: string;
      }
    | { tag: 'NotFound' }
    | { tag: 'Reading' }
  >({ tag: 'Reading' });
  const [time, setTime] = useState(5);
  useEffect(() => {
    if (previewData.tag !== 'NotFound') return;
    if (time > 0) {
      setTimeout(() => setTime(prev => prev - 1), 1000);
    } else {
      pushRouting('/home')();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time, previewData.tag]);

  const pushRouting = (({ pushRouting }) => (path: string) => () =>
    pushRouting({ path }, true))(useRouting());
  const { effect } = usePreviewGlobalUIItemsEffect(pushRouting('/home'));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);

  useEffect(() => {
    const dataURL_ = readDataURL();
    const comment = readComment();
    const withSNS = readSNS();
    if (dataURL_ && withSNS && comment !== null) {
      setPreviewData({ tag: 'Read', dataURL: dataURL_, withSNS, comment });
    } else {
      setPreviewData({ tag: 'NotFound' });
    }
    return removePreviewLocalStorage;
  }, []);

  const StateRenderer: ComponentProps<typeof Preview>['StateRenderer'] = ({
    setDataURL,
  }) => {
    useEffect(() => {
      previewData.tag === 'Read' && setDataURL(previewData.dataURL);
    }, [setDataURL]);
    return (
      <>
        {previewData.tag === 'Read' && (
          <div
            className="py-6 grid items-center justify-center"
            style={{ backgroundColor: '#52525b' }}>
            <img src={previewData.dataURL} alt="プレビュー画像" />
          </div>
        )}
      </>
    );
  };
  const StateController: ComponentProps<
    typeof Preview
  >['StateController'] = () => <></>;
  return (
    <>
      <div className="bg-white">
        {previewData.tag === 'NotFound' ? (
          <div className={`p-2 pb-6`}>
            <WithEmptyString
              View={() => <></>}
              isEmpty
              empty={{
                message: `プレビュー画像が見つかりませんでした。${time}秒後にホーム画面へ遷移します。`,
              }}
            />
          </div>
        ) : (
          <Preview
            {...{
              defaultState: {},
              extra: {},
              topixExtra: [],
              onCancel: pushRouting('/home'),
              StateController,
              StateRenderer,
              modalShowedSNS:
                previewData.tag === 'Read' ? previewData.withSNS : undefined,
              initialComment:
                previewData.tag === 'Read' ? previewData.comment : null,
            }}
          />
        )}
      </div>
    </>
  );
};
